module.exports = __webpack_public_path__ + "media/fonts/Gotham Book-b6e803be8fc1a5258c5e52ac6a0c0ace.otf";